import { RougeDataSets } from '../../data/rouge-data-sets.js';

function dtoToAggProps(dto) {
    const raw = {
        zones: dto.zones,
        face2FaceSeparation: dto.face2FaceSeparation,
        face2SideSeparation: dto.face2SideSeparation,
        dataset: RougeDataSets[dto.dataset],
        optimisePlots: dto.optimisePlots,
        unboundedTailor: dto.unboundedTailor
    };
    return raw;
}

export { dtoToAggProps };
//# sourceMappingURL=dto-to-agg-props.js.map
